module.exports = __webpack_public_path__ + "images/logout5946b5a5d7d273045dd1fb26a73e9e71.svg";